import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from '../App'
import ErrorBoundary from '../components/ErrorBoundary'
import '../styles/application.css'

// NOTE: the former GoogleOAuthProvider wrapper (@react-oauth/google) was a
// leftover from the removed client-side auth — sign-in is a server-side
// OmniAuth form now. The package can be dropped from package.json whenever
// the lockfile is next regenerated.
function bootstrap() {
  const container = document.getElementById('react-root')
  if (!container) return

  createRoot(container).render(
    <React.StrictMode>
      <ErrorBoundary>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    </React.StrictMode>
  )
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap)
} else {
  bootstrap()
}
